import { inject, Injectable } from '@angular/core';

import { useRolloutPlanStore } from '../../../+state/rollout/rollout-plan.store';

@Injectable({ providedIn: 'root' })
export class TargetProductGroupsService {
  private store = inject(useRolloutPlanStore);

  async loadProductGroups() {
    await this.store.loadProductGroups();
  }
}
